import { useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { Grid, Popover, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { withRouter } from "react-router";
import RefrezhButton from "components/RefrezhButton";
import ContactRefrezhModal from "components/Message/ContactRefrezhModal";
import RemakeProductOrderModal from "containers/PatientDataPage/RemakeProductOrderModal";
import { hasRole, ROLES } from "utils/userStorage";
import Base from "components/Message/Base";
import InfoIcon from "basicComponents/Icons/InfoIcon";
import clsx from "clsx";
import "../../containers/PatientDataPage/mystyles.css"

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  poDetails: {
    borderBottom: "1px solid rgba(0,0,0,0.46)",
    paddingBottom: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "& > *:nth-child(2)": {
      paddingLeft: theme.spacing(2),
    },

    "&.latest": {
      borderBottom: "none",
      paddingBottom: theme.spacing(0),
    },
  },
  title: {
    marginRight: theme.spacing(2),
    minWidth: "5%",
    "&.old": {
      color: "#e68058",
    },
  },
  textColor: {
    color: "#e6805890",
    "&.primary": {
      color: "#000000DE",
    },
  },
  title_margin: {
    marginLeft: theme.spacing(1),
  },
  changesRow: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    "&.old": {
      color: "#e68058",
    },
  },
  changesRowList: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  content: {
    padding: theme.spacing(2, 0),
    textAlign: "center",
  },
  actionContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderTop: "1px solid rgba(0,0,0,0.46)",
    padding: theme.spacing(2),
  },
  marginTop: {
    marginTop: theme.spacing(2),
  },
  marginSides: {
    margin: theme.spacing(0, 2),
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
    borderRadius: "15px",
    border: "1px solid black",
    maxWidth: "300px",
    lineHeight: 1,
  },
  messageBox: {
    border: "1px solid rgba(0,0,0,0.24)",
    borderColor: "rgba(0,0,0,0.24)",
  },
}));

function OrderMessage({
  activeMessage = {},
  onClose,
  onCloseMessage,
  history,
  onRemakeRequest,
  remakeProductOrder,
  onResetRemakeProductOrder,
  showPatient = false,
  title,
}) {
  const classes = useStyles({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenRefitting, setIsOpenRefitting] = useState(false);
  const [isOpenRemake, setIsOpenRemake] = useState(false);
  const [isOpenGuarantee, setIsOpenGuarantee] = useState(false);
  const PROCESSED = 4;
  window.setIsOpenRefitting = setIsOpenRefitting
  window.setIsOpenRemake = setIsOpenRemake
  
  const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // this one
  const changeRow = useCallback((index, array, message, old) => {
    return (
      <Grid
        container
        className={clsx(classes.poDetails, {
          latest: index === array.length - 1,
        })}
      >
        <Grid item xs={12} sm={12}>
          <div
            className={clsx(classes.changesRow, {
              old: old,
            })}
          >
            <FormattedMessage {...messages.order_changed_change} />
            <div className={classes.title_margin}>
              {" "}
              {message[0].toLowerCase()} :
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12}>
          <div
            className={clsx(classes.changesRow, {
              old: old,
            })}
          >
            <Typography
              variant="caption"
              color={"textPrimary"}
              className={clsx(classes.title, {
                old: old,
              })}
            >
              <FormattedMessage {...messages.order_changed_from} />
            </Typography>
            <div> {message[1]}</div>
          </div>
          <div
            className={clsx(classes.changesRow, {
              old: old,
            })}
          >
            <Typography
              variant="caption"
              color={"textPrimary"}
              className={clsx(classes.title, {
                old: old,
              })}
            >
              <FormattedMessage {...messages.order_changed_to} />
            </Typography>
            <div> {message[2]}</div>
          </div>
        </Grid>
      </Grid>
    );
  });

  const body = useMemo(
    () => (
      <div className={classes.body} data-cy="bodyMessage">
        <Grid container className={classes.poDetails}>
          <Grid item xs={12} sm={6}>
            <Typography
              className={clsx(classes.textColor, {
                primary:
                  activeMessage.productOrder.upperProductRemake ||
                  (!activeMessage.productOrder.upperProductRemake &&
                    !activeMessage.productOrder.lowerProductRemake),
              })}
              variant="caption"
            >
              <FormattedMessage {...messages.order_placed_upper_product} />
            </Typography>
            <Typography
              variant="subtitle1"
              className={clsx(classes.textColor, {
                primary:
                  activeMessage.productOrder.upperProductRemake ||
                  (!activeMessage.productOrder.upperProductRemake &&
                    !activeMessage.productOrder.lowerProductRemake),
              })}
            >
              {activeMessage.productOrder.upperProductName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="caption"
              className={clsx(classes.textColor, {
                primary:
                  activeMessage.productOrder.lowerProductRemake ||
                  (!activeMessage.productOrder.upperProductRemake &&
                    !activeMessage.productOrder.lowerProductRemake),
              })}
            >
              <FormattedMessage {...messages.order_placed_lower_product} />
            </Typography>
            <Typography
              variant="subtitle1"
              className={clsx(classes.textColor, {
                primary:
                  activeMessage.productOrder.lowerProductRemake ||
                  (!activeMessage.productOrder.upperProductRemake &&
                    !activeMessage.productOrder.lowerProductRemake),
              })}
            >
              {activeMessage.productOrder.lowerProductName}
            </Typography>
          </Grid>
        </Grid>
        {activeMessage.changes &&
          activeMessage.changes.length > 0 && (
            <div className={classes.poDetails}>
              <div className={classes.changesRowList}>
                {activeMessage.changes.map((change, index, array) =>
                  changeRow(
                    index,
                    array,
                    change,
                    activeMessage.latestMessageId !== activeMessage.id,
                  ),
                )}
              </div>
            </div>
          )}
        {activeMessage.buttonsEnabled && (
          <div className={classes.poDetails}>
            <div style={{ textAlign: "center" }} data-cy="viewFullOrder">
              <RefrezhButton
                className={classes.marginTop}
                onClick={() => {
                  history.push(
                    `/patient/${activeMessage.patient.id}/order/${
                      activeMessage.productOrder.id
                    }`,
                  );
                }}
              >
                <FormattedMessage
                  {...messages.order_placed_full_order_action}
                />
              </RefrezhButton>
            </div>
            {activeMessage.productOrder.editPossible && (
              <div data-cy="editOrder">
                <RefrezhButton
                  onClick={() => {
                    if (
                      hasRole([ROLES.Admin, ROLES.CS]) ||
                      activeMessage.productOrder.status !== PROCESSED
                    ) {
                      if (
                        activeMessage.productOrder.lowerProductRemake ||
                        activeMessage.productOrder.upperProductRemake
                      ) {
                        history.push(
                          `/order/patient/${
                            activeMessage.patient.id
                          }/treatment/${activeMessage.productOrder.id}`,
                          {
                            fromPatient: activeMessage.patient.id,
                          },
                        );
                      } else {
                        history.push(
                          `/order/patient/${
                            activeMessage.patient.id
                          }/treatment`,
                          {
                            fromPatient: activeMessage.patient.id,
                          },
                        );
                      }
                    } else {
                      setIsOpen(true);
                    }
                  }}
                  className={classes.marginTop}
                >
                  <FormattedMessage {...messages.order_placed_edit_action} />
                </RefrezhButton>
              </div>
            )}
          </div>
        )}
        <div className={classes.content}>
          <Typography className={classes.marginTop} variant="caption">
            <FormattedMessage {...messages.order_placed_delivery_date} />{" "}
            <span
              style={{ marginLeft: "5px", display: "inline-flex" }}
              data-cy="popupSTL"
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
            >
              <InfoIcon size={15} />
            </span>
          </Typography>
          {activeMessage.productOrder.deliveryDate ? (
            <Typography
              variant="subtitle1"
              display="block"
              data-cy="deliverDateMessage"
            >
              {moment
                .unix(activeMessage.productOrder.deliveryDate)
                .format("dddd DD-MM-YYYY")}
            </Typography>
          ) : (
            <Typography
              variant="subtitle1"
              display="block"
              data-cy="deliverDateMessage"
            >
              <FormattedMessage
                {...messages.order_placed_without_deliverydate}
              />
            </Typography>
          )}
          {/* here */}
          {activeMessage.type === 4 && (
            <div>
              {(() => {
                if(isJsonString(activeMessage.message)){
                  var obj = JSON.parse(activeMessage.message)
                  return <div>
                    <Typography variant="subtitle1">
                      {obj.message}
                    </Typography>
                    <div style={{display:"flex", alignItems:"center",gap:"10px",justifyContent:"center"}}>
                      <div style={{position:"relative",width:"50px",height:"50px",margin:"10px"}}>
                        <img onMouseEnter={(e) => {
                          e.target.style['z-index'] = 90
                        }} onMouseLeave={(e) => {
                          e.target.style['z-index'] = ""
                        }} className="photo" src={`${__URLS__["api"]}${obj.data}`} 
                        style={{top:"0px",left:"0px",width:'50px',height:'50px',margin:"10px",borderRadius:"3px"}}/>
                      </div>

                      <a  href={`${__URLS__["api"]}${obj.data}`} target="_blank">
                        download
                      </a>
                    </div>
                    {/* <img onMouseEnter={(e) => {
                        e.target.style.width = '400px'
                        e.target.style.height = '400px'
                      }} onMouseLeave={(e) => {
                        e.target.style.width = '50px'
                        e.target.style.height = '50px'
                      }} src={`${__URLS__["api"]}${obj.data}`} style={{width:'50px',height:'50px',margin:"10px",borderRadius:"3px"}}/> */}
                  </div>
                }else{
                  return <Typography variant="subtitle1">
                    {activeMessage.message}
                  </Typography>
                }
              })()}
              
              {activeMessage.status < 2 && (
                <RefrezhButton
                  style={{
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  className={classes.marginTop}
                  onClick={() => {
                    onCloseMessage(activeMessage.id);
                  }}
                >
                  <FormattedMessage {...messages.order_changed_message_read} />
                </RefrezhButton>
              )}
            </div>
          )}
        </div>
        {(activeMessage.productOrder.refittingPossible ||
          activeMessage.productOrder.nextOrderPossible) && (
          <div className={classes.actionContainer}>
            {activeMessage.productOrder.refittingPossible && (
              <div data-cy="reOrderButton">
                <RefrezhButton id="opnieuwpassenplaatsenbtn"
                  onClick={() => {
                    setIsOpenRefitting(true);
                  }}
                  className={classes.marginSides}
                >
                  {/* opnieuw passen plaatsen  */}
                  <FormattedMessage {...messages.order_placed_reorder_action} />
                </RefrezhButton>
              </div>
            )}
            {activeMessage.productOrder.nextOrderPossible && (
              <div data-cy="followOrder">
                <RefrezhButton
                  onClick={() => {
                    getPaul('productOrder','productPlanId',activeMessage.productOrder.productPlanId,(productorders) => {
                      try{
                        var i = productorders.findIndex(po => po.id == activeMessage.productOrder.id)
                        var nextorder = productorders[i + 1]
                        history.push(
                          `/order/patient/${activeMessage.patient.id}/treatment/${nextorder.id}`,
                          {
                            fromPatient: activeMessage.patient.id,
                          },
                        );
                      }catch(e){
                        console.error(e)
                      }
                    })
                  }}
                  className={classes.marginSides}
                >
                  {/* plaats vervolgorder */}
                  <FormattedMessage
                    {...messages.order_placed_next_order_action}
                  />
                </RefrezhButton>
              </div>
            )}
          </div>
        )}
        {activeMessage.productOrder.remakeGuaranteePossible && (
          <div className={classes.actionContainer}>
            <div data-cy="remakeOrderButton">
              <RefrezhButton
                onClick={() => {
                  setIsOpenRemake(true);
                }}
                className={classes.marginSides}
              >
                <FormattedMessage {...messages.order_placed_remake_action} />
              </RefrezhButton>
            </div>
            <div data-cy="warrantyOrderButton">
              <RefrezhButton
                onClick={() => {
                  setIsOpenGuarantee(true);
                }}
                className={classes.marginSides}
              >
                <FormattedMessage {...messages.order_placed_warranty_action} />
              </RefrezhButton>
            </div>
          </div>
        )}
        <Popover
          open={open}
          anchorEl={anchorEl}
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Typography variant="caption">
            <FormattedMessage {...messages.order_placed_popover_info} />
          </Typography>
        </Popover>
      </div>
    ),
    [
      activeMessage.patient,
      activeMessage.productOrder.deliveryDate,
      activeMessage.productOrder.id,
      activeMessage.productOrder.lowerProductName,
      activeMessage.productOrder.lowerProductRemake,
      activeMessage.productOrder.refittingPossible,
      activeMessage.productOrder.remakeGuaranteePossible,
      activeMessage.productOrder.editPossible,
      activeMessage.productOrder.status,
      activeMessage.productOrder.upperProductName,
      activeMessage.productOrder.upperProductRemake,
      anchorEl,
      classes.actionContainer,
      classes.body,
      classes.content,
      classes.marginSides,
      classes.marginTop,
      classes.paper,
      classes.poDetails,
      classes.popover,
      history,
      open,
      onCloseMessage,
    ],
  );

  return (
    <>
      <Base
        key="message"
        className={classes.messageBox}
        onClose={onClose}
        shouldRenderPatient={showPatient}
        title={title}
        activeMessage={activeMessage}
      >
        {body}
      </Base>
      <ContactRefrezhModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <RemakeProductOrderModal
        isOpenRefitting={isOpenRefitting}
        isOpenRemake={isOpenRemake}
        isOpenGuarantee={isOpenGuarantee}
        onClose={() => {
          onResetRemakeProductOrder();
          setIsOpenGuarantee(false);
          setIsOpenRemake(false);
          setIsOpenRefitting(false);
        }}
        onRemakeRequest={onRemakeRequest}
        remakeProductOrder={remakeProductOrder}
        dataCy="remakeModal"
        activeMessage={activeMessage}
      />
    </>
  );
}

OrderMessage.propTypes = {
  activeMessage: PropTypes.shape({
    updatedAt: PropTypes.number,
    changesList: PropTypes.array,
    productOrder: PropTypes.shape({
      lowerProductName: PropTypes.string,
      upperProductName: PropTypes.string,
      phase: PropTypes.string,
      avadentCaseId: PropTypes.string,
      deliveryDate: PropTypes.number,
      refittingPossible: PropTypes.bool,
      nextOrderPossible: PropTypes.bool,
    }),
    patient: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  onClose: PropTypes.func.isRequired,
  onCloseMessage: PropTypes.func,
  onRemakeRequest: PropTypes.func.isRequired,
  remakeProductOrder: PropTypes.object,
  onResetRemakeProductOrder: PropTypes.func.isRequired,
  showPatient: PropTypes.bool,
};


function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export default withRouter(OrderMessage);
